import { queryOptions } from '@tanstack/react-query'

import { attributionViewerKeys } from './queryKeys'

import { getMeetingAttributionLive, getMeetingAttributionRefined } from '@/api/internal'

export const refinedArtifactQueryOptions = (meetingId: string, jobId: string | null = null) =>
  queryOptions({
    queryKey: attributionViewerKeys.artifact(meetingId, 'refined', jobId),
    queryFn: ({ signal }) => getMeetingAttributionRefined(meetingId, signal, jobId),
  })

export const liveArtifactQueryOptions = (meetingId: string) =>
  queryOptions({
    queryKey: attributionViewerKeys.artifact(meetingId, 'live'),
    queryFn: ({ signal }) => getMeetingAttributionLive(meetingId, signal).then((response) => response.data),
  })
